import React from 'react';
import { CONTACT_INFO, MANAGING_DIRECTOR, PIZZERIA_NAME } from '../constants';
import SectionHeading from './SectionHeading';

const Datenschutz = () => {
  return (
    <div className="section-surface section-surface-tinted">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
        <SectionHeading
          eyebrow="Datenschutz"
          title="Datenschutzerklärung"
        />

        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-2xl font-semibold tracking-tight text-stone-950">
              Verantwortlicher
            </h3>
            <div className="mt-5 space-y-2 text-base text-stone-700">
              <p className="font-semibold text-stone-950">{PIZZERIA_NAME}</p>
              <p>{CONTACT_INFO.addressLines[0]}</p>
              <p>{CONTACT_INFO.addressLines[1]}</p>
              <p className="pt-2 text-sm text-stone-600">
                Vertreten durch:{' '}
                <span className="font-semibold">{MANAGING_DIRECTOR} (Geschäftsführer)</span>
              </p>
              <p className="pt-2">
                <a href={CONTACT_INFO.emailHref} className="font-semibold text-orange-700">
                  {CONTACT_INFO.email}
                </a>
              </p>
              <p className="text-sm text-stone-600">Stand: 19.04.2026</p>
            </div>
          </section>

          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-2xl font-semibold tracking-tight text-stone-950">
              Hosting & Server-Logs
            </h3>
            <p className="mt-5 text-sm leading-7 text-stone-700">
              Beim Aufruf der Website verarbeitet der Hosting-Anbieter technisch notwendige
              Daten (z.B. IP-Adresse, Datum/Uhrzeit, angeforderte Seite, User-Agent) in
              Server-Logfiles, um die Website auszuliefern und zu schützen.
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Hosting-Anbieter: <span className="font-semibold">Netlify</span>
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Rechtsgrundlage ist in der Regel Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an sicherem Betrieb und Fehleranalyse).
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Empfänger/Kategorie: Hosting-Anbieter und ggf. eingesetzte technische Dienstleister
              (z.B. CDN) zur Auslieferung und Absicherung der Website.
            </p>
          </section>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">Zwecke</h3>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-7 text-stone-700">
              <li>Auslieferung und Stabilität der Website</li>
              <li>IT-Sicherheit (z.B. Abwehr von Missbrauch und Angriffen)</li>
              <li>Bearbeitung von Anfragen per E-Mail oder Telefon</li>
            </ul>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Rechtsgrundlagen: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) und – bei
              Kommunikation – Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Anbahnung) oder lit. f DSGVO.
            </p>
          </section>

          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">Kontakt</h3>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Wenn du uns per E-Mail oder Telefon kontaktierst, verarbeiten wir die
              übermittelten Daten zur Bearbeitung deiner Anfrage.
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Auf der Kontaktseite ist Google Maps eingebunden. Beim Laden der Karte werden Inhalte
              von Google nachgeladen; Google kann dabei personenbezogene Daten (z.B. IP-Adresse)
              verarbeiten. Wenn du auf die Karte klickst, wird eine Route in Google Maps geöffnet.
              Es gelten die Datenschutzbestimmungen von Google.
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Das Kontaktformular auf dieser Website sendet aktuell keine Daten an uns,
              sondern bleibt lokal im Browser (Demo-Formular).
            </p>
          </section>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">
              Cookies / Speicherung auf Endgeräten
            </h3>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Wir setzen nach aktuellem Stand keine Analyse- oder Marketing-Cookies ein.
              Auf der Kontaktseite ist jedoch Google Maps eingebunden; dabei können durch
              Google Cookies gesetzt und personenbezogene Daten verarbeitet werden.
              Soweit für die Einbindung eine Einwilligung erforderlich ist, erfolgt sie auf
              Grundlage von § 25 TDDDG und Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Rechtsgrundlage für Einwilligungen bei Zugriff auf Endeinrichtungen ist
              § 25 TDDDG.
            </p>
          </section>

          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">Speicherdauer</h3>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Server-Logfiles werden je nach Hosting-Anbieter für einen begrenzten Zeitraum
              gespeichert und danach gelöscht oder anonymisiert.{' '}
              <span className="font-semibold">
                Die Speicherung erfolgt nur so lange, wie es für Sicherheit und Fehleranalyse
                erforderlich ist, und wird anschließend gelöscht oder anonymisiert.
              </span>
            </p>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Kommunikationsdaten (E-Mail/Telefon) speichern wir nur so lange, wie es für die
              Bearbeitung erforderlich ist und ggf. gesetzliche Aufbewahrungspflichten bestehen.
            </p>
          </section>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">Deine Rechte</h3>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-7 text-stone-700">
              <li>Auskunft, Berichtigung, Löschung, Einschränkung</li>
              <li>Widerspruch gegen Verarbeitungen (insb. bei Art. 6 Abs. 1 lit. f DSGVO)</li>
              <li>Datenübertragbarkeit (soweit anwendbar)</li>
              <li>Beschwerde bei einer Datenschutzaufsichtsbehörde</li>
            </ul>
            <p className="mt-4 text-sm leading-7 text-stone-700">
              Sofern eine Verarbeitung auf Einwilligung beruht, kannst du diese Einwilligung
              jederzeit mit Wirkung für die Zukunft widerrufen.
            </p>
          </section>

          <section className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-semibold text-stone-950">Rechtsgrundlagen</h3>
            <div className="mt-4 space-y-3 text-sm leading-7 text-stone-700">
              <p>
                Informationspflichten bei Datenerhebung: Art. 13 DSGVO.
              </p>
              <p>
                Hinweis zu Drittlandübermittlungen: Beim Hosting über Netlify kann es zu einer
                Verarbeitung personenbezogener Daten in Ländern außerhalb der EU/EEA (insb. USA)
                kommen. Netlify nutzt für internationale Übermittlungen geeignete Garantien,
                insbesondere EU-Standardvertragsklauseln (SCC); für Übermittlungen in die USA
                kann zusätzlich das EU-US Data Privacy Framework einschlägig sein.
              </p>
              <div className="flex flex-col gap-2">
                <a
                  className="inline-flex items-center gap-2 font-semibold text-orange-700 hover:text-orange-800"
                  href="https://dejure.org/gesetze/DSGVO/13.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gesetzestext: Art. 13 DSGVO (dejure.org) <span aria-hidden="true">↗</span>
                </a>
                <a
                  className="inline-flex items-center gap-2 font-semibold text-orange-700 hover:text-orange-800"
                  href="https://www.gesetze-im-internet.de/ttdsg/__25.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gesetzestext: § 25 TDDDG (gesetze-im-internet.de) <span aria-hidden="true">↗</span>
                </a>
                <a
                  className="inline-flex items-center gap-2 font-semibold text-orange-700 hover:text-orange-800"
                  href="https://www.bfdi.bund.de/DE/Buerger/Inhalte/Allgemein/Datenschutz/Informationspflichten.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Erklärung: Informationspflichten (BfDI) <span aria-hidden="true">↗</span>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
